import ContentAudioList from './content/ContentAudioList';
import ContentTVList from './content/ContentTVList';

const EMPTY_ARR = [];
const EMPTY_OBJ = {};
const TICKET_TYPE = 'mobile';

const AUDIO = 'audio';
const MLBTV = 'tv';
const MiLBTV = 'tv';
const mediaTitleMap = {
    Audio: {
        type: AUDIO
    },
    MLBTV: {
        type: MLBTV
    },
    MiLBTV: {
        type: MiLBTV
    }
};

const formatContentMediaLinks = (epg) => {
    return epg.reduce(
        (accumulator, media) => {
            const mediaType = media?.title;
            const items = media?.items ?? [];
            if (mediaType && items.length && mediaType in mediaTitleMap) {
                const mappedType = mediaTitleMap[mediaType];
                const type = mappedType.type;

                if (type.toLowerCase() === AUDIO) {
                    accumulator[type] = new ContentAudioList(items);
                } else if (type === MLBTV) {
                    accumulator[type] = new ContentTVList(items, mediaType);
                }
            };

            return accumulator;
        },
        {}
    );
};

const formatLineup = (lineup) => {
    const formattedLineup = [];
    lineup.forEach(function (player, index) {
        formattedLineup.push({
            person: {
                id: player.id,
                lastFirstName: player.lastName + ', ' + player.useName,
                primaryPosition: player.primaryPosition
            },
            battingOrder: (index + 1) + '00',
            startingPosition: player.primaryPosition
        });
    });
    return formattedLineup;
};

const formatMediaLinks = (broadcasts) => {
    const items = broadcasts.reduce(
        (acc, media) => {
            // Return early if media is not available on MLBs streaming platforms
            if (!media.availableForStreaming) {
                return acc;
            }

            if (media.type === 'TV') {
                acc.tv.push(media);
            } else {
                acc.audio.push(media);
            }
            return acc;
        },
        {
            tv: [],
            audio: []
        }
    );

    return {
        tv: new ContentTVList(items.tv, ''),
        audio: new ContentAudioList(items.audio)
    };
};

class ScheduleModel {
    constructor (data, params) {
        const dates = data && data.dates && data.dates.length && data.dates.slice(-1)[0];
        const game = dates.games && dates.games.slice(-1)[0];
        const broadcasts = game.broadcasts || EMPTY_ARR;
        const homeLineup = game.lineups?.homePlayers || EMPTY_ARR;
        const awayLineup = game.lineups?.awayPlayers || EMPTY_ARR;
        const scheduleTeams = game.teams;
        const tickets = game.tickets || EMPTY_ARR;
        const xrefIds = game.xrefIds || EMPTY_ARR;
        const epg = game.content?.media?.epg || EMPTY_ARR;
        this.contentMediaLinks = formatContentMediaLinks(epg) || EMPTY_OBJ;
        this.mediaLinks = formatMediaLinks(broadcasts) || EMPTY_OBJ;
        this.xrefIds = xrefIds;
        const nationalBroadcasts = this.nationalBroadcasts = {
            tv: [],
            radio: []
        };

        const promotionIds = this.promotionIds = {};
        this.story = game.story?.link || '';

        this.isNationalTvExclusive = broadcasts
            .filter((broadcast) => broadcast.type === 'TV')
            .every((broadcast) => broadcast.isNational === true);

        this.isFreeGame = broadcasts
            .some((broadcast) => broadcast.freeGame === true);

        const teams = this.teams = {
            home: {
                shortname: 'home',
                tickets: null,
                broadcast: {
                    tv: [],
                    radio: []
                },
                probablePitcher: scheduleTeams.home.probablePitcher,
                lineup: formatLineup(homeLineup)

            },
            away: {
                shortname: 'away',
                tickets: null,
                broadcast: {
                    tv: [],
                    radio: []
                },
                probablePitcher: scheduleTeams.away.probablePitcher,
                lineup: formatLineup(awayLineup)
            }
        };

        let i;
        let len;
        let homeAway;
        let type;
        let target;
        let temp;
        const pushedIds = {};

        /**
         * Sort the broadcasts into team and national buckets.
         * Don't repeat any national broadcasts, check their ids to
         * see if it's been added already.
         */
        for (i = 0, len = broadcasts.length; i < len; i++) {
            temp = broadcasts[i];
            homeAway = temp && temp.homeAway;
            if (!temp.isNational && homeAway) {
                type = temp.type.toLowerCase();
                target = teams[homeAway.toLowerCase()];
                if (target) {
                    if (type === 'tv') {
                        target.broadcast.tv.push({
                            id: temp.id,
                            name: temp.name
                        });
                    } else {
                        target.broadcast.radio.push({
                            id: temp.id,
                            name: temp.name
                        });
                    }
                }
            } else if (!pushedIds[temp.id]) {
                type = temp.type.toLowerCase();
                if (type === 'tv') {
                    nationalBroadcasts.tv.push({
                        id: temp.id,
                        name: temp.name
                    });
                    pushedIds[temp.id] = true;
                } else {
                    nationalBroadcasts.radio.push({
                        id: temp.id,
                        name: temp.name
                    });
                    pushedIds[temp.id] = true;
                }
            }
        }
        for (i = 0, len = tickets.length; i < len; i++) {
            temp = tickets[i];
            if (temp && temp.ticketType === TICKET_TYPE && temp.ticketLinks) {
                type = temp.ticketLinks;
                teams.home.tickets = type.home;
                teams.away.tickets = type.away;
                break;
            }
        }

        for (i = 0, len = xrefIds.length; i < len; i++) {
            const xref = xrefIds[i];
            if (xref && xref.xrefId === 'true') {
                promotionIds[xref.xrefType] = true;
            }
        }
    }
}

export default ScheduleModel;
